import * as gzSplashDirective from './splash.directive';

export default angular.module('gazelle.components.splash', [
])
  .directive(gzSplashDirective.name, gzSplashDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/splash/splash.module.js